import { maskIdSegment } from './maskIdSegment';

/**
 * React Query의 `queryKey`에서 **식별용 스코프 문자열만** 뽑아낸다.
 *
 * - 왜 `queryHash` 원문을 쓰지 않는가: `queryHash`는 queryKey 전체의 JSON이다. 이 앱의
 *   query key factory 컨벤션이 `[..., { ...params }]` 형태라, 파라미터 객체에 사용자 입력이
 *   그대로 담긴다. 예를 들어 `queryKey.signup.verifyId(id)`가 실패하면 사용자가 입력한
 *   로그인 아이디가 리포트에 실려 나간다. 앞으로 추가되는 민감 파라미터도 자동으로 유출된다.
 * - SigNoz SDK의 스크러버는 리포트 **message**에 적용되지 않는다 — 즉 보내는 쪽에서
 *   걸러내지 않으면 그대로 저장된다.
 * - 그래서 string·number 세그먼트(도메인·액션·인덱스 등 식별자)만 남기고, 객체·배열·boolean·
 *   null·undefined 세그먼트는 전부 버린다. 남는 게 없으면 `undefined`.
 * - 남긴 세그먼트도 `maskIdSegment`로 마스킹한다 — 고카디널리티 식별자(uuid 등)가 SigNoz 인덱스
 *   attribute(`report.key`)으로 새면 집계가 유저별로 쪼개진다. 개별 건은 trace로 따라간다.
 */
export function toQueryScope(queryKey: readonly unknown[]): string | undefined {
  const scope = queryKey
    .filter((seg): seg is string | number => typeof seg === 'string' || typeof seg === 'number')
    .map((seg) => maskIdSegment(String(seg)))
    .join('.');

  return scope === '' ? undefined : scope;
}
